import useSWR from "swr";
import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const version = (token) => Manager.client(token).get(Endpoints.version.version);

export const UseVersion = ({ access }) => {
  const { data, error } = useSWR(`${Endpoints.version.version}/${access}`, () =>
    version(access),
  );

  return {
    content: data ? data.data.data : "",
    error,
    loading: !error && !data,
  };
};
